import axios, { LONG_TIMEOUT } from '../../config/axios';
import apiPaths from '../apiPaths';

const onImportCall = (file, params) => {
  const formData = new FormData();
  formData.append('excel_file', file);

  return axios.post(`${apiPaths.importBase}/risks-and-policies`, formData, {
    params,
    timeout: LONG_TIMEOUT
  });
};

const onGetImportTemplate = (params) =>
  axios.get(`${apiPaths.importBase}/risks-and-policies-template`, {
    responseType: 'arraybuffer',
    params,
    timeout: LONG_TIMEOUT
  });

const onGetRisksAndPoliciesExportFile = () =>
  axios.get(`${apiPaths.importBase}/risks-and-policies-export-file`, {
    responseType: 'arraybuffer',
    timeout: LONG_TIMEOUT
  });

export { onImportCall, onGetImportTemplate, onGetRisksAndPoliciesExportFile };
